import { render, staticRenderFns } from "./SmartRewardsTerms.vue?vue&type=template&id=9d0887e6&scoped=true"
import script from "./SmartRewardsTerms.vue?vue&type=script&lang=js"
export * from "./SmartRewardsTerms.vue?vue&type=script&lang=js"
import style0 from "./SmartRewardsTerms.vue?vue&type=style&index=0&id=9d0887e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0887e6",
  null
  
)

export default component.exports